var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPashaLogoGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "gray",
  fillRule: "evenodd",
  clipPath: "url(#pasha-logo-gray_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.43 2.902h3.492v5.673H11.25v-1.28l3.134-3.132.154-.153z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.914 0 4.012 4.01-4.011 4.01-.904-.903V2.47H7.444z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.906 2.902v3.494l.953-.953.154-.154L7.3 8.575h1.28l-.001-5.673z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 9.913 4.011-4.01 4.01 4.01-.903.905H2.47v1.566z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.906 16.923V11.25l5.672.002v1.278l-3.132 3.133-.153.153.153.153.953.953z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.917 19.827-4.01-4.01 4.01-4.012.903.904v4.648h1.569z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.922 16.924-5.672-.001v-5.671h1.28l3.133 3.132.152.154.154-.154.953-.953z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.814 13.926-4.01-4.01.905-.905h4.646V7.444l2.47 2.47-4.011 4.01Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pasha-logo-gray_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h68.293v20H0z"
})))));
export default SvgPashaLogoGray;